import { IGeoProjection, ProjectedPoint, ProjectionContext } from './GeoProjection';
import { latLonToUTM } from './utm';

export class UTMProjection implements IGeoProjection {
  private _originE = 0;
  private _originN = 0;
  private _zone?: string;
  private _hemi: 'N' | 'S' = 'N';
  private readonly _altitudeScale: number;
  private readonly _trackScale: number;

  constructor(options?: { utmZone?: string; altitudeScale?: number; trackScale?: number }) {
    this._zone = options?.utmZone;
    this._altitudeScale = options?.altitudeScale ?? 1.0;
    this._trackScale = options?.trackScale ?? 1.0;
  }

  async project(lat: number, lon: number, alt?: number): Promise<ProjectedPoint> {
    const utm = await latLonToUTM(lat, lon, this._zone);
    if (!this._zone) {
      // Initialize origin on first project call
      this._originE = utm.easting;
      this._originN = utm.northing;
      this._zone = utm.zone;
      this._hemi = utm.hemisphere;
    }
    const x = (utm.easting - this._originE) * this._trackScale;
    const z = (utm.northing - this._originN) * this._trackScale;
    const y = (alt ?? 0) * this._altitudeScale;
    return { x, y, z };
  }

  getContext(): ProjectionContext {
    return {
      utmZone: this._zone,
      hemisphere: this._hemi,
      originEasting: this._originE,
      originNorthing: this._originN
    };
  }
}

